<template>
  <div>
    <h1>Organização de Excursão - {{ groupTrip.name }}</h1>
    <v-container grid-list-md>
      <v-toolbar color="transparent" flat dense>
        <v-toolbar-items>
          <v-btn text to="/grouptrips">
            <v-icon>view_list</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text> <v-icon>list_alt</v-icon>Relatórios</v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in reports"
                :key="i"
                @click="showReport(i)"
              >
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout column>
        <v-flex md12 mt-3>
          <v-tabs
            centered
            background-color="primary"
            dark
            slider-color="primary"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab ripple>Quartos</v-tab>
            <v-tab ripple :disabled="!this.id">Voos</v-tab>
            <v-tab ripple :disabled="!this.id">Ônibus</v-tab>
            <v-tab ripple :disabled="!this.id">Guias</v-tab>
            <v-tab-item>
              <RoomListManagement :trip-id="id" :passengers="passengers" />
            </v-tab-item>
            <v-tab-item>
              <FlightListManagement :trip-id="id" :passengers="passengers" />
            </v-tab-item>
            <v-tab-item>
              <BusListManagement :trip-id="id" :passengers="passengers" />
            </v-tab-item>
            <v-tab-item>
              <TourGuideManagement :trip-id="id" />
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
    <OperationStatusCard
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
    />
    <v-dialog :value="reportDialog" persistent max-width="80%">
      <v-card>
        <v-card-title class="headline">{{ this.reportTitle }}</v-card-title>
        <v-card-text>
          <iframe
            width="100%"
            height="500px"
            :src="this.reportUrl"
            frameborder="0"
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeReport">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import api from "@/api";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
import RoomListManagement from "@/components/Trip/Organization/RoomListManagement";
import FlightListManagement from "@/components/Trip/Organization/FlightListManagement";
import BusListManagement from "@/components/Trip/Organization/BusListManagement";
import TourGuideManagement from "@/components/Trip/Organization/TourGuideManagement";
export default {
  name: "group-trip-organization",
  components: {
    OperationStatusCard,
    RoomListManagement,
    FlightListManagement,
    BusListManagement,
    TourGuideManagement
  },
  data() {
    return {
      reportTitle: null,
      reportDialog: false,
      reportUrl: null,
      reports: [
        {
          title: "Listagem dos Passageiros (Excel)",
          url: `/reports/grouptrips/${this.$route.params.id}/passengers/excel`,
          type: "xlsx"
        },
        {
          title: "Listagem de Passageiros",
          url: `/reports/grouptrips/${this.$route.params.id}/passengers?groupBy=None`,
          type: "pdf"
        },
        {
          title: "Listagem de Passageiros por Pacote",
          url: `/reports/grouptrips/${this.$route.params.id}/passengers?groupBy=Package`,
          type: "pdf"
        },
        {
          title: "Listagem de Passageiros por Unidade",
          url: `/reports/grouptrips/${this.$route.params.id}/passengers?groupBy=Branch`,
          type: "pdf"
        },
        {
          title: "Listagem de Bilhetes",
          url: `/reports/grouptrips/${this.$route.params.id}/tickets`,
          type: "pdf"
        },
        {
          title: "Listagem de Camisas",
          url: `/reports/grouptrips/${this.$route.params.id}/shirts`,
          type: "pdf"
        },
        {
          title: "Listagem de Passaportes",
          url: `/reports/grouptrips/${this.$route.params.id}/passports`,
          type: "pdf"
        },
        {
          title: "Listagem de Documentos",
          url: `/reports/grouptrips/${this.$route.params.id}/documents`,
          type: "pdf"
        },
        {
          title: "Listagem de Seguro",
          url: `/reports/grouptrips/${this.$route.params.id}/insurance`,
          type: "pdf"
        },
        {
          title: "Listagem de Voos",
          url: `/reports/grouptrips/${this.$route.params.id}/flights`,
          type: "pdf"
        },
        {
          title: "Listagem de Onibus",
          url: `/reports/grouptrips/${this.$route.params.id}/buses`,
          type: "pdf"
        },
        {
          title: "Listagem de Opcionais",
          url: `/reports/grouptrips/${this.$route.params.id}/addons`,
          type: "pdf"
        },
        {
          title: "Listagem de Quartos",
          url: `/reports/grouptrips/${this.$route.params.id}/roomlist`,
          type: "pdf"
        }
      ],
      groupTrip: {},
      passengers: []
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    showReport(reportIndex) {
      api
        .request("GET", this.reports[reportIndex].url, null, {}, "arraybuffer")
        .then(response => {
          var reportTitle = this.reports[reportIndex].title;
          var reportType = this.reports[reportIndex].type;
          var reportUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: `application/${reportType}`
            })
          );

          if (reportType == "pdf") {
            this.reportUrl = reportUrl;
            this.reportTitle = reportTitle;
            this.reportDialog = true;
          } else {
            var link = document.createElement("a");
            link.href = reportUrl;
            link.download = `${this.groupTrip.name} - ${reportTitle}.${reportType}`;
            link.click();

            setTimeout(function() {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(reportUrl);
              link.remove();
            }, 100);
          }
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    },
    closeReport() {
      window.URL.revokeObjectURL(this.reportUrl);
      this.reportUrl = null;
      this.reportTitle = null;
      this.reportDialog = false;
    }
  },
  mounted() {
    if (this.id) {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/trips/groupTrips/${this.id}`)
        .then(response => {
          this.groupTrip = response.data.groupTrip;
          return api.request("GET", `/trips/${this.id}/passengers`);
        })
        .then(response => {
          this.passengers = response.data.passengers || [];
          this.$refs.loadingStatusCard.close();
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    }
  }
};
</script>
